export default {
    "open_equity": "Ekuitas Awal",
    "bonus": "Bonus",
    "closed_positions": "Posisi Tertutup",
    "finance": "Keuangan",
    "watchlist": "Daftar pantauan",
    "calendar": "Kalender",
    "symbol_information": "Informasi Simbol",
    "contact_size": "Ukuran kontak",
    "min_tick_size": "Ukuran Centang Min",
    "min_lot": "Min Lot",
    "max_lot": "Max Lot",
    "pip_size": "Ukuran Pip",
    "stop_limit_levels": "Level Stop & Limit",
    "base_currency": "Kutipan Mata Uang",
    "swap_type": "Jenis Swap",
    "digits": "Digit",
    "trade_id": "ID Perdagangan",
    "sell_buy": "Jual/Beli",
    "instrument": "Instrumen",
    "open_current_price": "Harga Terbuka/Saat Ini",
    "s_slash_l": "S / L",
    "profit_slash_loss": "Laba/Rugi",
    'net_pl':'P/L Bersih',
    "comment": "Komentar",
    "action": "Tindakan",
    "proximity": "Kedekatan",
    "buy_stop": "Beli Berhenti",
    "buy_limit": "Batas Beli",
    "stop_loss": "Stop Loss",
    "rate": "Nilai",
    "take_profit": "Ambil Untung",
    "price": "Harga",
    "maximum_20_characters": "Maksimal 20 karakter",
    "btn_place_buy_order": "Tempatkan Pesanan Beli",
    "btn_place_sell_order": "Tempatkan Pesanan Jual",
    "change": "Perubahan",
    "descrption": "Deskripsi",
    "asset_class": "Kelas Aset",
    "subclass": "Subkelas",
    "major": "Mayor",
    "size_of_1_pip": "Ukuran 1 pip",
    "Min_position_size": "Min. Ukuran Posisi",
    "Max_position_size": "Maks. Ukuran Posisi",
    "leverage": "Leverage",
    "daily_swap_points": "Poin penukaran harian",
    "long": "Panjang",
    "short": "pendek",
    "market_hours_local_time": "Jam Pasar (Waktu Setempat)",
    "main_trading": "Utama/Perdagangan",
    "copy_trade": "Salin Perdagangan",
    "view_modes": "Lihat Mode",
    "reports": "Laporan",
    "pivot_table": "Tabel Pivot",
    "pp": "PP",
    "s1": "S1",
    "s2": "S2",
    "s3": "S3",
    "r1": "R1",
    "r2": "R2",
    "r3": "R3",
    "list_property": "Daftar Properti",
    "overview": "Ikhtisar",
    "day_low": "Hari Rendah",
    "prev_close": "Sebelumnya Tutup",
    "day_high": "Hari Tinggi",
    "52_week_low": "52 Minggu Rendah",
    "1_day_range": "Kisaran 1 hari",
    "52_day_range": "Kisaran 52 hari",
    "daily": "Setiap hari",
    "weekly": "Mingguan",
    "monthly": "Bulanan",
    "moving_averages": "Rata-rata Bergerak",
    "technical_indicators": "Indikator Teknis",
    "charts": "Grafik",
    "trade_log": "Log Perdagangan",
    "create_new_watchlist": "Buat Daftar Pantauan Baru",
    "net_profit": "Laba Bersih",
    "maximum_equity_drawdown": "Penarikan Ekuitas Maksimum",
    "profit_percentage": "Persentase Keuntungan",
    "opening_balance": "Saldo Awal",
    "current_balance": "Saldo Saat Ini",
    "deposit": "Deposit",
    "withdrawal": "Penarikan",
    "economic_calendar": "Kalender Ekonomi",
    "dashboard": "Dasbor",
    "markets": "Pasar",
    "portfolio": "Portofolio",
    "buzz": "Buzz",
    "view_profile": "Lihat Profil",
    "equity": "Ekuitas",
    "realized_profit": "Laba yang Direalisasikan",
    "unrealized_profit": "Laba yang Belum Direalisasi",
    "balance": "Keseimbangan",
    "used_margin": "Margin yang digunakan",
    "free_margin": "Margin Bebas",
    "profile": "Profil",
    "settings": "Pengaturan",
    "theme": "Tema",
    "logout": "Keluar",
    "trading_account": "Akun Perdagangan",
    "quick_links": "Tautan Cepat",
    "back": "Kembali",
    "previous": "Sebelumnya",
    "forecast": "Perkiraan",
    "actual": "Sebenarnya",
    "data": "Tanggal",
    "margin_level": "Tingkat Margin",
    "news": "Berita",
    "unrealised_pl": "P/L BERSIH YANG BELUM DIREALISASI",
    "unrealised_gross_pl": "P / L KOTOR YANG BELUM DIREALISASI",
    "quantity": "Kuantitas",
    "trailing_sl": "Trailing SL",
    "sell": "Jual",
    "buy": "Beli",
    "open_positions": "Posisi Terbuka",
    "close_all_profitable": "Tutup Semua Menguntungkan",
    "close_all_losing": "Tutup Semua Kerugian",
    "close_all_buy": "Tutup Semua Beli",
    "close_all_sell": "Tutup Semua Jual",
    "no": "Tidak.",
    "yes": "Ya.",
    "are_you_sure": "Apakah Anda yakin ingin",
    "current_market_rates": "dengan harga pasar saat ini?",
    "close_all": "Tutup Semua",
    "watchlists": "Daftar pantauan",
    "default": "Default",
    "add_new_watchlist": "Tambahkan Daftar Pantauan Baru",
    "delete_watchlist?": "Apakah Anda yakin ingin menghapus Daftar Pantauan ini?",
    "cancel": "Batal",
    "delete": "Menghapus",
    "delete_alert": "Apakah Anda yakin ingin menghapus peringatan ini?",
    "condition": "Kondisi",
    "triggered": "Dipicu",
    "active": "Aktif",
    "alert": "Waspada",
    "alerts": "Peringatan",
    "going_below": "Pergi ke bawah",
    "going_above": "Pergi ke Atas",
    "bid_price": "Harga Penawaran",
    "ask_price": "Harga Permintaan",
    "symbol": "Simbol",
    "edit_alert": "Edit Peringatan",
    "create_alert_on": "Buat Peringatan pada",
    "info": "Info",
    "daily_range": "Kisaran Harian",
    "spread": "Penyebaran",
    "contract_size": "Ukuran Kontrak",
    "min_trade_size": "Ukuran Perdagangan Min",
    "max_trade_size": "Ukuran Perdagangan Maks",
    "swap_long": "Tukar Panjang",
    "swap_short": "Swap Short",
    "create_alert": "Buat Peringatan",
    "remove_watchlist": "Hapus dari daftar pantauan",
    "trading_view_chart": "Grafik Tampilan Perdagangan",
    "chart": "Bagan",
    "add": "Menambahkan",
    "add_instruments_watchlist": "Menambahkan Instrumen ke Daftar Pantauan Anda",
    "h": "H",
    "l": "L",
    "cryptos": "Cryptos",
    "indices": "Indeks",
    "forex": "Forex",
    "fx": "FX",
    "stocks": "Saham",
    "comm": "Comm",
    "commodities": "Komoditas",
    "low": "Rendah",
    "high": "Tinggi",
    "change_percentage": "Ubah %",
    "bid": "Penawaran",
    "ask": "Tanyakan",
    "order": "Pesan",
    "commission": "Komisi",
    "swap": "Tukar",
    "open_date": "Tanggal Buka",
    "lots": "Banyak.",
    "b_slash_s": "B / S",
    "open_price": "Harga Terbuka",
    "order_price": "Harga Pesanan",
    "current_price": "Harga saat ini",
    "comments": "Komentar",
    "modify": "Memodifikasi",
    "close": "Tutup",
    "ok": "Baiklah.",
    "trailing_stop": " Trailing Stop",
    "trailing_stop_loss": "Trailing Stop Loss",
    "quntity": "Quntity",
    "price_level": "Tingkat Harga",
    "type": "Jenis",
    "trades": "Perdagangan",
    "order_id": "ID Pesanan",
    "modify_order": "Ubah Pesanan",
    "revert": "Kembalikan",
    "id": "ID",
    "sl": "SL",
    "tp": "TP",
    "close_order": "Tutup Pesanan",
    "trail_s_slash_l": "Jalur S/L",
    "pnl_s": "Pnl",
    "direction": "Arah",
    "modify_position": "Ubah Posisi",
    "close_price": "Harga Penutupan",
    "close_date": "Tanggal Penutupan",
    "total_p_slash_l": "Total P/L",
    "place_new_order": "Tempatkan Pesanan Baru",
    "close_time": "Waktu Tutup",
    "open_time": "Waktu Buka",
    "p_slash_l": "P / L",
    "reason": "Alasan",
    "qty": "Jumlah",
    "pending_orders": "Pesanan Tertunda",
    "order_type": "Jenis Pesanan",
    "close_all_orders": "Apakah Anda yakin ingin menutup semua Order yang terbuka?",
    "place_order": "Tempatkan Pesanan",
    "advanced_options": "Opsi Lanjutan",
    "available_margin": "Margin yang Tersedia",
    "trade": "Perdagangan",
    "positions": "Posisi",
    "orders": "Pesanan",
    "history": "Sejarah",
    "summary": "Ringkasan",
    "summary_from": "Ringkasan Dari:",
    "performance": "Kinerja",
    "profitability": "Profitabilitas",
    "password_validation": "Kata sandi harus terdiri dari minimal 8 karakter, satu karakter khusus, satu huruf, satu angka.",
    "note": "Catatan",
    "change_password": "Ubah Kata Sandi",
    "submit": "Kirim",
    "select_server_type": "Pilih Jenis Server",
    "create_demo_account": "Buat akun demo",
    "create_new_account": "Membuat akun baru",
    "account_id": "ID Akun",
    "name": "Nama",
    "currency": "Mata uang",
    "security": "Keamanan",
    "amount": "Jumlah",
    "select_leverage": "Pilih Leverage",
    "select_currency": "Pilih Mata Uang",
    "save_settings": "Menyimpan Pengaturan",
    "large": "Besar",
    "small": "Kecil",
    "font_size": "Ukuran Font",
    "units": "Unit",
    "select_show": "Pilih Tampilkan",
    "order_position_size": "Ukuran Pesanan / Posisi Dalam",
    "custom": "Kustom",
    "month": "Bulan",
    "days": "Hari",
    "day": "Hari",
    "select": "Pilih",
    "history_range": "Rentang Sejarah",
    "default_lot_size": "Ukuran Lot Default",
    "local_time": "Waktu setempat",
    "server": "Server",
    "timezone": "Zona waktu",
    "enable": "Aktifkan",
    "modify_trade": "Memodifikasi Perdagangan",
    "open": "Buka",
    "enter_quantity": "Masukkan kuantitas",
    "tooltip": "Keterangan alat",
    "field": "Bidang",
    "value": "Nilai",
    "date_time": "Tanggal/Waktu",
    "market": "Pasar",
    "all": "Semua",
    "verify": "Verifikasi",
    "volume": "Volume",
    "lot": "banyak",
    "quantity_required": " Kuantitas diperlukan.",
    "stop_loss_required": " Diperlukan stop loss.",
    "distance_points": "Jarak dari Harga Saat Ini",
    "points": "Poin",
    "back_to_login": "Kembali ke Login",
    "forgot_password": "Lupa Kata Sandi?",
    "enter_username": "Masukkan Nama Pengguna",
    "login": "Masuk",
    "remember_me": "Ingatlah aku.",
    "login_another_account": "Masuk dengan Akun lain",
    "2fa_verification": "Verifikasi 2FA",
    "my_profile": "Profil Saya",
    "user_name": "Nama Pengguna",
    "email": "Email",
    "already_have_account": " Sudah memiliki akun?",
    "register": "Daftar",
    "last_name": "Nama belakang",
    "first_name": "Nama depan",
    "password": "Kata sandi",
    "disable_two_factor_auth": "Menonaktifkan Autentikasi Dua Faktor",
    "enter_6_digit_code": "Masukkan 6 digit kode verifikasi yang dihasilkan.",
    "enable_two_factor_authentication": "Mengaktifkan Autentikasi Dua Faktor",
    "please_click_2fa_enable": "Silakan klik opsi 2FA yang ingin Anda aktifkan.",
    "download_authenticator_app": "Unduh Aplikasi Authenticator",
    "download_install_google_authenticator": "Unduh dan instal Authy atau Google Authenticator ke ponsel atau tablet Anda.",
    "scan_code": "Pindai Kode QR",
    "open_authentication_app_camera": "Buka aplikasi autentikasi dan pindai gambar di sebelah kiri, menggunakan kamera ponsel Anda",
    "login_code": "Masuk dengan Kode Anda",
    "two_factor_authentication": "Autentikasi Dua Faktor",
    "2fa_already_enabled": "2FA Sudah Diaktifkan Silakan klik opsi 2FA yang ingin Anda nonaktifkan.",
    "usd": "USD",
    "eur": "EUR",
    "gbp": "GBP",
    "aud": "AUD",
    "enter_6_digit_code_placeholder": "Masukkan Kode 6 digit",
    "enter_google_verification_code": "Masukkan kode verifikasi Google",
    "trading_id_placeholder": "Masukkan id trading Anda",
    "password_placeholder": "Masukkan kata sandi Anda",
    "email_placeholder": "Masukkan email Anda",
    "enter_old_password": "Masukkan kata sandi saat ini",
    "enter_new_password": "Masukkan kata sandi baru",
    "enter_new_password_again": "Masukkan kata sandi baru lagi",
    "alpha_numeric_dashes_underscores_spaces": "hanya boleh berisi karakter alfa-numerik serta tanda hubung, garis bawah, dan spasi",
    "is_required": "diperlukan",
    "field_must_be": " bidang harus",
    "or_more": "atau lebih.",
    "or_less": "atau kurang.",
    "must_be_greater_then": "pasti lebih besar dari itu.",
    "must_be_less_then": "harus kurang dari itu",
    "not_valid": "tidak valid",
    "buy_stop_loss_error_message": "Stop Loss harus lebih kecil dari Harga Pasar",
    "trailing_stop_required": "Diperlukan Trailing Stop.",
    "trailing_stop_greater_zero": "Trailing Stop harus lebih besar dari",
    "target_price_required": "Diperlukan Harga Target.",
    "target_price_greater_trigger": "Harga target harus lebih besar dari harga saat ini dan",
    "trigger_price": "Harga Pemicu",
    "price_required": "Diperlukan harga.",
    "price_must_be_greater_than": "Harga harus lebih besar dari",
    "target_price_greater_price_level": "Target Harga harus Lebih Besar dari Tingkat Harga",
    "price_must_be_less_than": "Harga harus kurang dari",
    "and_greater_than_zero": "dan Lebih besar dari",
    "stop_loss_less_price_level_greater_zero": "Stop loss harus lebih kecil dari Level Harga dan lebih besar dari",
    "target_price_less_trigger": "Harga target Harus Kurang dari harga saat ini dan lebih besar dari",
    "sell_stop": "Sell Stop",
    "sell_limit": "Batas Jual",
    "sell_stop_loss_error_message": "Stop Loss harus lebih besar dari Harga Pasar",
    "placed_order_pending_wait": "Pesanan yang Anda lakukan tertunda, harap tunggu",
    "place_other_order": "Tempatkan Pesanan Lainnya",
    "no_account_id_found": "ID Akun Tidak Ditemukan",
    "target_price_must_less_than_trigger_price_greater_zero": "Harga Target harus lebih kecil dari harga Pemicu dan lebih besar dari",
    "sell_stop_loss_greater_trigger_price": "Stop Loss harus lebih besar dari harga pemicu",
    "create_new_alert": "Buat Peringatan Baru",
    "losing": "Kalah.",
    "winning": "Menang",
    "avg_trade_size": "Rata-rata Ukuran Perdagangan",
    "asset": "Aset",
    "trades_lost": "Perdagangan yang Hilang",
    "trades_won": "Perdagangan yang dimenangkan",
    "total_trades": "Total Perdagangan",
    "total_trading_volume": "Total Volume Perdagangan",
    "resend": "Kirim ulang",
    "reset_password_msg": "Silakan periksa alamat email untuk mendapatkan instruksi untuk mengatur ulang kata sandi Anda.",
    "server_type": "Jenis Server",
    "check_email": "Periksa Email Anda",
    "technicals": "Teknis",
    "disable": "Nonaktifkan",
    "amount_greater_100000": "Jumlahnya tidak boleh lebih besar dari 100000",
    "x": "X",
    "password_required": "Diperlukan kata sandi.",
    "proceed": "Lanjutkan",
    "turnkey_forex": "TurnkeyForex",
    "coinexx": "Coinexx",
    "finpro_trading": "Finpro Trading",
    "hankotrade": "Hankotrade",
    "brokers": "Pialang",
    "select_broker": "Pilih Pialang",
    "edit_price_alert": "Edit Peringatan Harga",
    "create_price_alert": "Buat Peringatan Harga",
    "maximum_100_characters": "Maksimal 100 karakter",
    "add_comment": "Tambahkan Komentar",
    "price_must_be": "Harga harus",
    "then": "kemudian",
    "crossing_above": "Menyeberang di Atas",
    "crossing_below": "Menyeberang di Bawah",
    "total_records": "Total Catatan",
    "no_data_found": "Tidak ada data yang ditemukan",
    "show_more": "Tampilkan lebih banyak",
    "show_less": "Tampilkan Lebih Sedikit",
    "at": "di",
    "trail": "Jejak",
    "order_pending": "Pesanan tertunda",
    "target_price_less_market_greater_zero": "Harga Target harus lebih kecil dari Kisaran Pasar dan lebih besar dari",
    "stop_loss_less_market_price_greater_zero": "Stop loss harus lebih kecil dari Harga Pasar Saat Ini dan lebih besar dari",
    "stop_loss_greater_market_range": "Stop loss harus lebih besar dari Kisaran Pasar",
    "target_price_greater_market_price": "Target Harga Harus Lebih Besar dari Harga Pasar Saat Ini",
    "watchlist_create": "Membuat Daftar Pantauan",
    "update": "Memperbarui",
    "delete_symbol": "Hapus Simbol",
    "are_sure_delete_symbol": "Apakah Anda yakin ingin menghapus Simbol ini?",
    "symbol_name": "Nama Simbol",
    "edit_symbol": "Edit Simbol",
    "enter_watchlist_name": "Masukkan Nama Daftar Pantauan",
    "search_title": "Simbol pencarian",
    "b": "B",
    "s": "S",
    "a": "A",
    "username": "Nama pengguna",
    "email_address": "Alamat email",
    "old_password_validation": "Diperlukan Kata Sandi Lama.",
    "old_password_greater_characters": "Kata Sandi Lama tidak boleh lebih dari 20 karakter",
    "new_password_validation": "Diperlukan Kata Sandi Baru",
    "confirm_password_is_required": "Diperlukan konfirmasi kata sandi.",
    "entered_password_not_match": "Kata sandi yang dimasukkan tidak cocok. Silakan coba lagi",
    "display_high_slash_low_grid_view": "Menampilkan Tinggi / Rendah dalam tampilan kisi-kisi",
    "display_spread_grid_view": "Tampilan menyebar dalam tampilan kisi-kisi",
    "select_to_date": "Pilih Sampai Saat Ini",
    "select_from_date": "Pilih Dari Tanggal",
    "select_show_order_slash_position_size_in": "Tampilkan Ukuran Pesanan / Posisi Masuk",
    "select_history_range": "Pilih Rentang Riwayat",
    "lot_size_greater_than": "Ukuran Lot tidak boleh lebih besar dari",
    "select_time_zone": "Pilih Zona Waktu",
    "select_font_size": "Memilih ukuran font",
    "select_mode_view_suits": "Pilih Mode Tampilan yang Sesuai untuk Anda.",
    "selected": "Dipilih",
    "basic_chart_view": "Tampilan Bagan Dasar",
    "grid_view": "Tampilan Kisi",
    "multi_chart_view": "Tampilan Multi Grafik",
    "settings_effect_trading_page": "Pengaturan ini hanya berlaku di halaman perdagangan.",
    "market_watch": "Pantauan Pasar",
    "favorite": "Favorit",
    "one_click_trading": "Perdagangan Satu Klik",
    "new_watchlist": "Daftar Pantauan Baru",
    "maximum_5_watchlists": "Anda dapat membuat maksimal 5 daftar pantauan.",
    "new_watchlist_successfully": "Daftar Pantauan Baru Berhasil Ditambahkan",
    "delete_watchlist": "Menghapus Daftar Pantauan",
    "delete_watchlist_successfully": "Daftar Pantauan telah berhasil Dihapus",
    "edit_watchlist": "Edit Daftar Pantauan",
    "watchlist_updated_successfully": "Daftar Pantauan telah berhasil diperbarui",
    "go_to_order": "Pergi untuk memesan",
    "search_filter_fx": "FX",
    "mon": "Mon",
    "tue": "Tue",
    "wed": "Menikah",
    "thu": "Kamis",
    "fri": "Fri",
    "sat": "Sat",
    "sun": "Matahari",
    "olivia_deo": "Olivia Deo",
    "risk": "Risiko",
    "profit": "Keuntungan",
    "copiers": "Mesin fotokopi",
    "win_rate": "Tingkat Kemenangan",
    "greetings_des": "Salam, sistem saya yang saya sajikan di sini membutuhkan pengaturan akun berikut: 600usd ---> 0.01 Lot Kami melakukan sangat sedikit perdagangan di sini setiap tahun, antara 60-200 perdagangan, Perdagangan yang sangat diperlukan sehingga - kami menjaga penarikan kami serendah mungkin dengan melakukan perdagangan yang sangat dibutuhkan. Kami berlayar di atas rata-rata 30 pip per perdagangan. *Izinkan semua perdagangan dari sistem ini mencapai hasil yang serupa. JADI, selamat datang saat Anda mengembangkan akun Anda dengan mantap bersama kami dan bersabarlah.",
    "live_profit": "Keuntungan Langsung",
    "overall": "Secara keseluruhan",
    "advanced_seats": "Kursi Tingkat Lanjut",
    "trading": "Perdagangan",
    "drawDown": "DrawDown",
    "pips": "Pips",
    "include_unrealized_pnl": "Sertakan Pnl yang Belum Direalisasi",
    "closed_trades_only": "Hanya Perdagangan Tertutup",
    "trades_volume": "Volume Perdagangan",
    "by_pair": "Dengan Pasangan",
    "best_worst": "Terbaik-Buruk",
    "ranking": "Peringkat",
    "paris": "Paris",
    "trading_news": "Berita Perdagangan",
    "prev": "Sebelumnya",
    "next": "Berikutnya",
    "follow": "Ikuti",
    "investment": "Investasi",
    "open_date_time": "Tanggal & Waktu Buka",
    "close_date_time": "Tanggal & Waktu Penutupan",
    "roll": "Gulung",
    "total": "Total",
    "aud_slash_cad": "AUD/CAD",
    "position_list": "Daftar posisi",
    "trade_history": "Riwayat Perdagangan",
    "completed": "Selesai",
    "rejected": "Ditolak",
    "pending_closed": "Tertunda Ditutup",
    "close_time_date": "Tanggal waktu penutupan",
    "status": "Status",
    "hedge_position": "Posisi Lindung Nilai",
    "partial_close": "Tutup Sebagian",
    "stop_loss_less_then": "Stop loss harus kurang dari",
    "greater_then_zero": "dan lebih besar dari itu",
    "trailing_stop_greater_one": "Trailing Stop harus lebih besar dari",
    "greater_then": "Harga Target harus lebih besar dari itu",
    "stop_loss_greater_then": "Stop loss harus lebih besar dari itu",
    "target_price_less_then": "Harga Target harus kurang dari",
    "volume_required": "Diperlukan volume.",
    "volume_less_then": "Volume harus kurang dari itu",
    "PNL": "PNL",
    "lot_size_partial": "Ukuran lot kurang dari penutupan sebagian",
    "price_greater_then": "Harga harus lebih besar dari itu",
    "stop_loss_less_greater_then_zero": "Stop loss harus lebih kecil dari Level Harga dan lebih besar dari 0",
    "trailing_stop_greate_then_zero": "Trailing Stop harus lebih besar dari itu",
    "stop_loss_trigger_price": "Stop loss harus lebih besar dari harga pemicu",
    "date_range": "Rentang Tanggal",
    "from": "Dari",
    "to": "Untuk",
    "target_price_greater_then_zero": "Harga Target harus lebih kecil dari Harga Pemicu dan lebih besar dari",
    "target_price_market_range_greater_zero": "Harga Target harus lebih kecil dari Kisaran Pasar dan lebih besar dari",
    "order_list": "Daftar pesanan",
    "close_all_trades": "Tutup Semua Perdagangan",
    "instrument_name": "Nama instrumen",
    "trade_logs": "Log perdagangan",
    "transaction_ID": "ID Transaksi",
    "add_more_leader": "Tambahkan Lebih Banyak Pemimpin",
    "total_Profit": "Total Laba",
    "invested": "Diinvestasikan",
    "market101_guard_enabled": "Penjaga Market101 Diaktifkan",
    "excessive_losses": "Pemimpin telah dinonaktifkan karena kerugian yang berlebihan.",
    "filter": "Filter",
    "remember_filters": "Ingat Filter",
    "toggle": "Beralih",
    "matrix": "Matriks",
    "select_all": "Pilih Semua",
    "term": "Istilah",
    "apply": "Menerapkan",
    "clear_all": "Hapus semua",
    "follow_more": "Ikuti Lebih Lanjut",
    "go_to_dashboard": "Buka Dasbor",
    "are_you_sure_stop_coping": "Apakah Anda yakin ingin berhenti menyalin Master ini?",
    "invested_amount": "Jumlah yang Diinvestasikan",
    "max": "Max",
    "insufficient_funds": "Dana di Rekening Tidak Mencukupi.",
    "enter_valid_amount": "Masukkan jumlah yang valid.",
    "maximum_amount_allowed": "Jumlah maksimum yang diperbolehkan adalah hingga",
    "available_capital": "Modal yang tersedia",
    "copy_open_trades": "Salin Perdagangan Terbuka",
    "stop_following": "Berhenti Mengikuti",
    "leaders": "Pemimpin",
    "back_to_manual_trading": "Kembali ke Perdagangan Manual",
    "advanced_stats": "Statistik Lanjutan",
    "view_all": "Lihat Semua",
    "roi": "ROI",
    "load_more": "Muat Lebih Banyak",
    "powered_by": "Didukung oleh",
    "act_trader": "Pedagang Bertindak"
  }


// WEBPACK FOOTER //
// ./src/plugins/lang/languages/id.js